import { BrowserRouter as Router, Routes, Route, Link, useLocation } from 'react-router-dom';
import './App.css';
import Legal from './Legal';
import Privacy from './Privacy';
import DebugExtension from './debug-extension/DebugExtension';
import GeneralRules from './debug-extension/GeneralRules';
import ValamarDemo from './demo/ValamarDemo';
import TaxiRadenovic from './taxi-radenovic/TaxiRadenovic';
import SeaCloudMute from './products/SeaCloudMute';
import SeaCloudMuteInstall from './products/SeaCloudMuteInstall';
import Hero from './components/Hero';
import Stats from './components/Stats';
import Services from './components/Services';
import TechStrip from './components/TechStrip';
import About from './components/About';
import TrustSignals from './components/TrustSignals';
import HowItWorks from './components/HowItWorks';
import Contact from './components/Contact';
import CookieNotice from './components/CookieNotice';
import ProductSpotlight from './components/ProductSpotlight';
import ZetSpotlight from './components/ZetSpotlight';

function Navbar() {
  return (
    <nav className="navbar">
      <div className="navbar-inner">
        <Link to="/" className="navbar-brand">
          <img src="/images/seacloud-logo.png" alt="SeaCloud Software" className="navbar-logo-img" />
          <span className="navbar-brand-text">SeaCloud <span className="navbar-brand-soft">Software</span></span>
        </Link>
        <div className="navbar-links">
          <a href="/#services" className="nav-link">Services</a>
          <a href="/#about" className="nav-link">About</a>
          <Link to="/seacloud-mute" className="nav-link">SeaCloud Mute</Link>
          <a href="/#contact" className="nav-link nav-link-cta">Contact</a>
        </div>
      </div>
    </nav>
  );
}

function Home() {
  return (
    <main>
      <Hero />
      <Stats />
      <ProductSpotlight />
      <ZetSpotlight />
      <Services />
      <TechStrip />
      <About />
      <TrustSignals />
      <HowItWorks />
      <Contact />
    </main>
  );
}

function AppShell() {
  const location = useLocation();
  const hideChrome =
    location.pathname.startsWith('/demo/valamar') ||
    location.pathname.startsWith('/demo/taxi-radenovic');

  return (
    <>
      {!hideChrome && <Navbar />}
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/legal" element={<Legal />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/debug-extension" element={<DebugExtension />} />
        <Route path="/debug-extension/general-rules" element={<GeneralRules />} />
        <Route path="/demo/valamar" element={<ValamarDemo />} />
        <Route path="/demo/taxi-radenovic/:lang?" element={<TaxiRadenovic />} />
        <Route path="/seacloud-mute" element={<SeaCloudMute />} />
        <Route path="/seacloud-mute/install" element={<SeaCloudMuteInstall />} />
      </Routes>
      {!hideChrome && <CookieNotice />}
    </>
  );
}

function App() {
  return (
    <Router>
      <AppShell />
    </Router>
  );
}

export default App;
